<template>
  <div class="project-details-page">
    <section class="section-project-details-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section pb-2 section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-1">
                <div class="card-profile-image">
                  <a href="#">
                    <!-- <img v-lazy="'img/theme/Departin.jpg'" class="rounded-circle"> -->
                    <img
                      :src=" projectDetailsWithActivities && projectDetailsWithActivities.campaign_detail.logo_id ? (ImageURl+projectDetailsWithActivities.campaign_detail.logo_id) : defaultImage"
                      class="rounded-circle"
                    />
                  </a>
                </div>
              </div>
              <div class="col-lg-9 order-lg-2">
                <div class="card-profile-stats">
                  <h3 class="title">{{projectDetailsWithActivities.campaign_detail.name}}</h3>
                  <p>{{projectDetailsWithActivities.campaign_detail.tagline}}</p>
                </div>
              </div>
            </div>
            <div class="mt-1 pb-5 pt-3 border-top">
              <div class="row justify-content-center">
                <div class="col-lg-3">
                  <div class="donation-info">
                    <div class="amount">
                      <span>{{$t('Total_Contribution_Amount')}}</span>
                      <h3>
                        <i class="fa fa-rub" aria-hidden="true"></i>
                        {{projectDetailsWithActivities.campaign_detail.fund_collected}}
                      </h3>
                    </div>
                    <div class="doantion-btns">
                      <b-button
                        @click="$bvModal.show('modal-userInfo')"
                        block
                        variant="warning"
                      >{{$t('Donation_Now')}}</b-button>
                      <b-button
                        @click="$bvModal.show('share-link')"
                        block
                        variant="outline-warning"
                      >{{$t('Share')}}</b-button>
                      <BankDetails></BankDetails>
                      <ShareLink v-bind:queryParams="queryParams"></ShareLink>
                    </div>
                  </div>
                </div>
                <div class="col-lg-9">
                  <p>{{projectDetailsWithActivities.campaign_detail.description}}</p>
                  {{selectedScroll}}
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
    <ProjectActivities v-bind:activityData="this.projectDetailsWithActivities"></ProjectActivities>
  </div>
</template>
<script>
import ProjectActivities from "./components/ProjectActivities";
import BankDetails from "./components/BankDetails";
import ShareLink from "./components/ShareLink";
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      projectDetailsWithActivities: {},
      paginatedProjectActivities: [],
      ImageURl: "http://88.99.171.147:3000/api/file/",
      selectedScroll: null,
      defaultImage: "/default-image.png",
      pagination: {
        page: 1,
        rowsPerPage: 100
      }
    };
  },
  name: "ProjectDetails",
  queryParams: null,
  components: {
    ProjectActivities,
    BankDetails,
    ShareLink
  },
  mounted() {
    console.log("p details route", this.$route.query.q);
    this.queryParams = this.$route.query.q;
    this.getProjectDetails();
    // this.getActivityList();
    var me = this;
    setTimeout(() => {
      const listElm = document.querySelector("#infinite-list");
      if (listElm) {
        console.log("list element");
        listElm.addEventListener("scroll", e => {
          if (
            listElm.scrollTop + listElm.clientHeight >=
            listElm.scrollHeight
          ) {
            console.log("list element end");

            me.getActivityList();
          }
        });
      }
    }, 1000);
  },
  methods: {
    getProjectDetails() {
      const token = localStorage.getItem("token");
      var _request = this.getRequest();
      var queryString = qs.stringify(_request);
      var urlWithService =
        process.env.VUE_APP_API_URL +
        `/campaigns/default/${this.$route.query.q}?`;
      urlWithService = urlWithService + queryString;
      axios({
        method: "get",
        url: urlWithService,
        headers: { Authorization: ` ${token}` }
      })
        .then(Response => {
          if (Response) {
            this.projectDetailsWithActivities = Response.data || {};
            this.pagination.page = parseInt(this.pagination.page + 1);

            this.$emit("activitydata", this.projectDetailsWithActivities);
            console.log("org info", this.orgInfo);
          }
        })
        .catch(error => this.$toasted.show(error));
    },

    getRequest() {
      return {
        sorts: { sequence: "DESC" },

        pagination: {
          page: this.pagination.page,
          page_size: this.pagination.rowsPerPage
        }
      };
    },

    getActivityList() {
      let me = this;
      const token = localStorage.getItem("token");
      var _request = this.getRequest();
      console.log("req", _request);
      var queryString = qs.stringify(_request);
      var urlWithService =
        process.env.VUE_APP_API_URL +
        `/campaign-activity/${me.$route.query.q}?`;
      urlWithService = urlWithService + queryString;

      axios({
        method: "get",
        url: urlWithService,
        headers: { Authorization: ` ${token}` }
        // params:this.pagination
      })
        .then(Response => {
          if (Response) {
            // this.paginatedProjectActivities = Response.data.list || []
            me.projectDetailsWithActivities.campaign_activities.list = me.projectDetailsWithActivities.campaign_activities.list.concat(
              Response.data.list
            );
            me.pagination.page = parseInt(me.pagination.page + 1);
            console.log("appended activites are", me.pagination.page);
            me.$forceUpdate();
          }
        })
        .catch(error => console.log("erreror in get bank fun", error));
    }
  }
};
</script>
